import React, { useContext, useEffect, useState, useRef } from "react";
import { Col, Row, Button, CardBody, Card, Input, Label } from "reactstrap";
import _ from "lodash";
import { useParams, useNavigate } from "react-router-dom";
import { ServiceThreadSpinner, AttachmentManager } from "../";
import { api, constants, helpers, dateHelpers, UserContext } from "../../utils";
import { DesktopContainer } from "../../layouts";
import Select from "react-select";
import axios from "axios";
import { toast } from "react-toastify";
import DebounceInput from "react-debounce-input";
import { usePreviousHook } from "../../components/SpecEditComponents/index";

const blankForm = {
   actionBy: "",
   actionByTitle: "",
   actionDate: "",
   actionId: 0,
   actionType: 0,
   approvalComments: "",
   approvalDate: "",
   approvedBy: "",
   attachmentType: 0,
   attention: "",
   createdDate: "",
   creditAmount: 0,
   creditRequested: false,
   displayId: "",
   initial: true,
   itemType: "",
   itemWithDesc: "",
   longTerm: "",
   lotNumber: "",
   originator: "",
   poNumber: "",
   poReceivedDate: "",
   problemDescription: "",
   problemTypeDescription: "",
   problemTypeId: 0,
   qualityCode: "",
   quantity: "",
   responseDate: "",
   responseRequired: false,
   rootCause: "",
   shortTerm: "",
   status: 0,
   statusDescription: "",
   supplier: "",
   vendorItemWithDescription: "",
   vendorWithName: "",
   itemTypeSelect: { label: "", value: "" },
   poNumberSelect: { label: "", value: "" },
   poReceivedDateSelect: { label: "", value: "" },
   qualityCodeSelect: { label: "", value: "" },
};

const selectListInit = {
   itemTypes: [],
   poNumbers: [],
   poReceivedDates: [],
};

const status = {
   Open: 1,
   Closed: { label: "Investigation Completed", value: 2 },
   Canceled: { label: "Investigation Canceled", value: 5 },
};

export default function SupplierCorrectiveAction(props) {
   const cancelToken = axios.CancelToken;
   const navigate = useNavigate();
   const source = cancelToken.source();
   const userCtx = useContext(UserContext);
   const firstRender = useRef({
      supplier: true,
      poNumbers: true,
      itemTypes: true,
      poReceivedDates: true,
      followByUsers: true,
   });

   const { actionId } = useParams();
   const [isDisabled, setIsDisabled] = useState(false);
   const [isLoading, setIsLoading] = useState(false);
   const [loadingSelect, setLoadingSelect] = useState(false);
   const [selectList, setSelectList] = useState(selectListInit);
   const [staticSelectList, setStaticSelectList] = useState({
      problemTypes: [],
      followByUsers: [],
      qualityCodes: [],
      vendors: [],
   });
   const [supplierActionDto, setSupplierActionDto] = useState(blankForm);

   const itemTypePrev = usePreviousHook(supplierActionDto.itemTypeSelect);
   const poNumberPrev = usePreviousHook(supplierActionDto.poNumberSelect);
   const supplierPrev = usePreviousHook(supplierActionDto.supplierSelect);

   useEffect(() => {
      if (!_.isNil(actionId)) {
         setIsLoading(true);
         api
            .postS("Quality/FetchSupplierAction", { actionId: actionId }, source.Token)
            .then((r) => {
               if (r.data.success) {
                  let soa = r.data.supplierAction;
                  if (soa.supplier !== "") {
                     soa.supplierSelect = {
                        label: soa.vendorWithName,
                        value: soa.supplier,
                     };
                  }
                  if (
                     soa.status !== status.Open &&
                     userCtx &&
                     userCtx.currentUser &&
                     !userCtx.currentUser.isAdmin
                  )
                     setIsDisabled(true);
                  setSupplierActionDto({
                     // ...supplierActionDto,
                     ...soa,
                  });
                  setSelectList({
                     poNumbers: soa.poNumbers,
                     itemTypes: soa.itemTypes,
                     poReceivedDates: soa.poReceivedDates,
                  });
                  setStaticSelectList({
                     problemTypes: soa.problemTypes.map(item => item.active === false ? { ...item, isDisabled: true } : item),
                     followByUsers: soa.followByUsers,
                     qualityCodes: soa.qualityCodes,
                     vendors: soa.vendors,
                  });
               } else {
                  toast.error(r.data.message);
               }
            })
            .catch(api.catchHandler)
            .finally(() => {
               setIsLoading(false);
            });
      } else {
         console.error("actionId is not here");
      }

      return () => {
         source.cancel("axios request cancelled");
      };
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [actionId]);

   useEffect(() => {
      const cancelToken = axios.CancelToken;
      const source = cancelToken.source();
      if (firstRender.current.supplier) {
         firstRender.current.supplier = false;
         return;
      }
      if (supplierPrev === undefined) return;
      if (!_.isEqual(supplierPrev, supplierActionDto.supplierSelect)) {
         setSupplierActionDto({
            ...supplierActionDto,
            poNumberSelect: null,
            itemTypeSelect: null,
            poReceivedDateSelect: null,
         });
         if (supplierActionDto.supplierSelect === null) {
            setSelectList(selectList);
            return;
         }
         setLoadingSelect(true);
         api
            .fetch("Purchasing/POSearch", {
               VendorId: supplierActionDto.supplierSelect.value,
            })
            .then((r) => {
               if (r.data && r.data.success) {
                  let list = _.chain(r.data.message)
                     .unionBy((x) => x.poNumber)
                     .map((po) => {
                        return { label: po.poNumber, value: po.poNumber };
                     })
                     .value();
                  setSelectList({ ...selectList, poNumbers: list });
               }
            })
            .catch(api.catchHandler)
            .finally(() => setLoadingSelect(false));
      } else if (!_.isEqual(poNumberPrev, supplierActionDto.poNumberSelect)) {
         setSupplierActionDto({
            ...supplierActionDto,
            itemTypeSelect: null,
            poReceivedDateSelect: null,
         });
         if (supplierActionDto.poNumberSelect === null) {
            setSelectList({ ...selectList, itemTypes: [], poReceivedDates: [] });
            return;
         }
         setLoadingSelect(true);
         api
            .fetch("Purchasing/POSearch", {
               PONumber: supplierActionDto.poNumberSelect.value,
            })
            .then((r) => {
               if (r.data && r.data.success) {
                  setSelectList({
                     ...selectList,
                     itemTypes: _.map(r.data.message, (po) => {
                        return {
                           label: po.stItemWithDescription,
                           value: po.stItemNumber,
                        };
                     }),
                  });
               }
            })
            .catch(api.catchHandler)
            .finally(() => setLoadingSelect(false));
      } else if (!_.isEqual(itemTypePrev, supplierActionDto.itemTypeSelect)) {
         setSupplierActionDto({
            ...supplierActionDto,
            poReceivedDateSelect: null,
         });
         if (supplierActionDto.itemTypeSelect === null) {
            setSelectList({ ...selectList, poReceivedDates: [] });
            return;
         }
         setLoadingSelect(true);
         api
            .fetch(`Quality/FetchPOReceivedDates`, {
               PONumber: supplierActionDto.poNumberSelect.value,
               ItemNumber: supplierActionDto.itemTypeSelect.value,
            })
            .then((r) => {
               if (r.data && r.data.success)
                  setSelectList({
                     ...selectList,
                     poReceivedDates: _.map(r.data.message, (po) => {
                        let receivedDate = dateHelpers.toLongDateString(po.receiptDate);
                        return { label: receivedDate, value: receivedDate };
                     }),
                  });
            })
            .catch(api.catchHandler)
            .finally(() => setLoadingSelect(false));
      }
      // code here
      return () => {
         source.cancel("axios request cancelled");
      };
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [supplierActionDto]);

   function ColPrompt({ title }) {
      return (
         <Col xs="3" className="text-white">
            <h5 style={{ textAlign: "right" }}>{title}:</h5>
         </Col>
      );
   }

   const getCommaDelimitedString = (list) => {
      let result = "";
      _.map(list, (x) => {
         if (typeof x.value === "string") {
            result += `${x.value.trim()},`;
         }
      });
      result = result.slice(0, -1);
      return result;
   };

   const onChange = (property, value, secProp = null, secValue = null) => {
      let copy = _.cloneDeep(supplierActionDto);
      if (!_.isNil(secProp) && !_.isNil(secValue)) _.set(copy, secProp, secValue);
      _.set(copy, property, value);
      setSupplierActionDto(copy);
   };

   const onChangeStatus = (property, value) => {
      if (value === supplierActionDto.status) value = 1;
      let copy = _.cloneDeep(supplierActionDto);
      _.set(copy, property, value);
      setSupplierActionDto(copy);
   };

   function RadioOption({ onChange, currentValue, classType, fieldName }) {
      return (
         <Col xs="2" className="text-white">
            <Label>
               <Input
                  type="radio"
                  name={fieldName}
                  onChange={onChange}
                  onClick={onChange}
                  defaultValue={currentValue === classType.value}
                  checked={currentValue === classType.value}
               />
            </Label>
            <span className="ms-2">
               {classType.label ? classType.label : classType}
            </span>
         </Col>
      );
   }

   const runReport = () => {
      //send the primary key action Id and the action Type to decide which report to retieve
      setIsLoading(true);
      api
         .postDownloadBinary(
            "Report/CorrectiveAction", {
               actionType: supplierActionDto.actionType,
               actionId: supplierActionDto.actionId,
            },
            constants.MIME_TYPES.pdf,
            supplierActionDto.displayId + ".pdf",
            "There was an error downloading this corrective action pdf"
         )
         .then((res) => {
            if (res?.data === false) {
               toast.error(res.message);
            }
         })
         .catch((error) => {
            api.catchHandler(error);
         })
         .finally(() => setIsLoading(false));
   };

   const SaveCorrectiveAction = () => {
      let copy = _.cloneDeep(supplierActionDto);
      let payload = {};
      // payload.poReceivedDateSelect = dateHelpers.formatDateForServer(poReceivedDateSelect.value);
      for (let key in copy) {
         let value = copy[key];
         if (_.includes(key, "Selec")) {
            let newKey = key.slice(0, key.length - 6);
            let newValue = value;
            if (_.isArray(value) && value.length) {
               newValue = getCommaDelimitedString(value);
            } else {
               newValue = helpers.valueFromSelect(value);
               newValue = _.trim(newValue);
            }
            Object.assign(payload, { [newKey]: newValue });
         } else {
            Object.assign(payload, { [key]: value });
         }
      }
      payload.poReceivedDate = dateHelpers.formatDateForServer(payload.poReceivedDate);
      const validated = ValidatePayload(payload);
      if (validated) {
         api
            .post("Quality/SaveVendorAction", payload)
            .then((r) => {
               if (r.data.success) {
                  navigate(0);
                  toast.info("Successfully updated");
               } else {
                  toast.error("Something isn't right... Please try again later");
                  throw new Error(r.data.message);
               }
            })
            .catch(api.catchHandler);
      }
   };

   const ValidatePayload = (payload) => {
      let errors = "";
      if (payload.problemTypeId === "") payload.problemTypeId = 0;
      if (payload.status === "") payload.status = 1;
      if (!payload.quantity) errors.concat("<br />Quantity is a required value");
      if (payload.quantity) {
         let number = Number(payload.quantity);
         if (_.isNaN(number))
            errors = errors.concat("<br />Quantity value is not formatted correctly");
      }
      if (typeof payload.problemTypeId === "string")
         payload.problemTypeId = parseInt(payload.problemTypeId ?? "0");
      if (payload.problemTypeId === 0)
         errors = errors.concat("<br />Problem Type is a required value");
      if (!payload.qualityCode)
         errors = errors.concat("<br />Quality Code is a required value");
      if (payload.creditRequested) {
         if (payload.creditAmount < 0 || _.isNil(payload.creditAmount))
            errors = errors.concat("<br />Credit Amount is a required value");
      }
      if (!payload.supplier || _.isEmpty(payload.supplier))
         errors = errors.concat("<br />Supplier is required");
      if (!payload.poNumber || _.isEmpty(payload.poNumber))
         errors = errors.concat("<br />PO Number is required");
      if (!payload.itemType || _.isEmpty(payload.itemType))
         errors = errors.concat("<br />Item Number is required");
      if (!_.isEmpty(selectList.poReceivedDates)) {
         if (!payload.poReceivedDate)
            errors = errors.concat("<br />PO Received Date is required");
      }
      if (!payload.problemDescription)
         errors = errors.concat("<br />Problem Description is a required value");
      if (payload.status !== 1) {
         if (!payload.rootCause)
            errors = errors.concat("<br />Root Cause is required to mark the action approved or canceled");
         if (!payload.longTerm)
            errors = errors.concat("<br />Short Term Action Taken is required to mark the action approved or canceled");
         if (!payload.shortTerm)
            errors = errors.concat("<br />Long Term Action Taken is required to mark the action approved or canceled");
      }

      if (_.isEmpty(errors)) return true;
      toast.error(errors);
      return false;
   };

   return (
      <DesktopContainer screenName={""}>
         <ServiceThreadSpinner on={isLoading}>
            <form>
               <fieldset disabled={isDisabled}>
                  <div className="filter-header">
                     <Row className="newCorrectiveAction">
                        <Col xs={3} />
                        <Col xs={6} className="text-white">
                           <h5>
                              {supplierActionDto.displayId
                                 ? supplierActionDto.displayId
                                 : "Determined upon save"}
                           </h5>
                        </Col>
                     </Row>
                     <Row className="newCorrectiveAction">
                        <ColPrompt title="Created Date" />
                        <Col xs={6} className="text-white">
                           <h5>
                              {dateHelpers.toLongDateString(supplierActionDto.createdDate)}
                           </h5>
                        </Col>
                     </Row>
                     <Row className="newCorrectiveAction">
                        <ColPrompt title="Created By" />
                        <Col xs={6} className="text-white">
                           <h5>{supplierActionDto.originator}</h5>
                        </Col>
                     </Row>
                     <Row className="newCorrectiveAction">
                        <ColPrompt title="Supplier" />

                        <Col xs={6}>
                           <Select
                              classNamePrefix="serviceThreadSelect"
                              options={staticSelectList.vendors}
                              value={supplierActionDto.supplierSelect}
                              onChange={(opt) => onChange("supplierSelect", opt)}
                              isClearable
                              isDisabled={isDisabled}
                           />
                        </Col>
                     </Row>
                     <Row className="newCorrectiveAction">
                        <ColPrompt title="PO Number" />
                        <Col xs={6}>
                           <Select
                              classNamePrefix="serviceThreadSelect"
                              options={selectList.poNumbers}
                              value={supplierActionDto.poNumberSelect}
                              onChange={(opt) => onChange("poNumberSelect", opt)}
                              placeholder={"Please select a supplier above..."}
                              isDisabled={loadingSelect || isDisabled}
                              isClearable
                           />
                        </Col>
                        <Col
                           className={"p-0"}
                           children={
                              <ServiceThreadSpinner left white small on={loadingSelect} children={null} />
                           }
                        />
                     </Row>
                     <Row className="newCorrectiveAction">
                        <ColPrompt title="Item Number" />
                        <Col xs={6}>
                           <Select
                              classNamePrefix="serviceThreadSelect"
                              options={selectList.itemTypes}
                              placeholder={"Please select po number from above..."}
                              value={supplierActionDto.itemTypeSelect}
                              onChange={(opt) => onChange("itemTypeSelect", opt)}
                              isDisabled={loadingSelect || isDisabled}
                              isClearable
                           />
                        </Col>
                        <Col
                           className={"p-0"}
                           children={
                              <ServiceThreadSpinner left white small on={loadingSelect} children={null} />
                           }
                        />
                     </Row>
                     <Row className="newCorrectiveAction">
                        <ColPrompt title="PO Received Date" />
                        <Col xs={6}>
                           <Select
                              classNamePrefix="serviceThreadSelect"
                              options={selectList.poReceivedDates}
                              value={supplierActionDto.poReceivedDateSelect}
                              placeholder={"Please select an item above..."}
                              onChange={(opt) => onChange("poReceivedDateSelect", opt)}
                              isDisabled={loadingSelect || isDisabled}
                              isClearable
                           />
                        </Col>
                        <Col
                           className={"p-0"}
                           children={
                              <ServiceThreadSpinner left white small on={loadingSelect} children={null} />
                           }
                        />
                     </Row>
                     <Row className="newCorrectiveAction">
                        <ColPrompt title="Attention" />
                        <Col xs={6} className="text-white">
                           <Input
                              type="text"
                              value={supplierActionDto.attention}
                              onChange={(e) => onChange("attention", e.target.value)}
                           />
                        </Col>
                     </Row>
                     <Row className="newCorrectiveAction">
                        <ColPrompt title="Response Required" />
                        <Col xs={6} className="text-white">
                           <Input
                              type="checkbox"
                              checked={supplierActionDto.responseRequired}
                              onChange={() => onChange("responseRequired", !supplierActionDto.responseRequired)}
                           />
                        </Col>
                     </Row>
                     <Row className="newCorrectiveAction">
                        <ColPrompt title="Response Date" />
                        <Col xs={6} className="text-white">
                           <DebounceInput
                              type="date"
                              onChange={(e) => onChange("responseDate", e.target.value)}
                              value={dateHelpers.formatDateForServer(supplierActionDto.responseDate)}
                              debounceTimeout={500}
                           />
                        </Col>
                     </Row>
                     <hr />
                     <Row className="newCorrectiveAction">
                        <ColPrompt title="Quality Code" />
                        <Col xs={6}>
                           <Select
                              classNamePrefix="serviceThreadSelect"
                              options={staticSelectList.qualityCodes}
                              value={supplierActionDto.qualityCodeSelect}
                              onChange={(opt) => onChange("qualityCodeSelect", opt)}
                              isDisabled={isDisabled}
                           />
                        </Col>
                     </Row>
                     <Row className="newCorrectiveAction">
                        <ColPrompt title="Problem Type" />
                        <Col xs={6}>
                           <Select
                              classNamePrefix="serviceThreadSelect"
                              options={staticSelectList.problemTypes}
                              value={supplierActionDto.problemTypeIdSelect}
                              onChange={(opt) => onChange("problemTypeIdSelect", opt)}
                              isDisabled={isDisabled}
                           />
                        </Col>
                     </Row>
                     <Row className="newCorrectiveAction">
                        <ColPrompt title="Lot Number" />
                        <Col xs={6} className="text-white">
                           <Input
                              type="text"
                              value={supplierActionDto.lotNumber}
                              onChange={(e) => onChange("lotNumber", e.target.value)}
                           />
                        </Col>
                     </Row>
                     <Row className="newCorrectiveAction">
                        <ColPrompt title="Credit Requested" />
                        <Col xs={6} className="text-white">
                           <Input
                              type="checkbox"
                              checked={supplierActionDto.creditRequested}
                              onChange={() => onChange("creditRequested", !supplierActionDto.creditRequested)}
                           />
                        </Col>
                     </Row>
                     {supplierActionDto.creditRequested && (
                        <Row className="newCorrectiveAction">
                           <ColPrompt title="Amount" />
                           <Col xxl={6} className="text-white">
                              <Input
                                 type="number"
                                 value={supplierActionDto.creditAmount}
                                 onChange={(e) => onChange("creditAmount", e.target.value)}
                                 placeholder={"Enter Credit Amount..."}
                              />
                           </Col>
                        </Row>
                     )}
                     <Row className="newCorrectiveAction">
                        <ColPrompt title="Quantity" />
                        <Col xs={6} className="text-white">
                           <Input
                              type="number"
                              className="no-spinner"
                              value={supplierActionDto.quantity}
                              onChange={(e) => onChange("quantity", e.target.value)}
                              placeholder={"Enter Quantity..."}
                           />
                        </Col>
                     </Row>
                     <Row
                        children={
                           <Col
                              xs={{ size: 6, offset: 3 }}
                              className="text-white"
                              children={"Problem Description:"}
                           />
                        }
                     />
                     <Row className="newCorrectiveAction">
                        <Col xs={{ size: 6, offset: 3 }} className="text-white">
                           <Input
                              type="textarea"
                              className="serviceThreadTextArea"
                              value={supplierActionDto.problemDescription}
                              maxLength={255}
                              style={{ height: "150px", marginTop: "4px" }}
                              onChange={(e) => onChange("problemDescription", e.target.value)}
                              placeholder={"Enter Description..."}
                           />
                        </Col>
                     </Row>
                     <Row
                        children={
                           <Col
                              xs={{ size: 6, offset: 3 }}
                              className="text-white"
                              children={"Root Cause of Problem:"}
                           />
                        }
                     />
                     <Row className="newCorrectiveAction">
                        <Col xs={{ size: 6, offset: 3 }} className="text-white">
                           <Input
                              type="textarea"
                              className="serviceThreadTextArea"
                              value={supplierActionDto.rootCause}
                              maxLength={255}
                              style={{ height: "150px", marginTop: "4px" }}
                              onChange={(e) => onChange("rootCause", e.target.value)}
                              placeholder={"Enter Description..."}
                           />
                        </Col>
                     </Row>
                     <Row
                        children={
                           <Col
                              xs={{ size: 6, offset: 3 }}
                              className="text-white"
                              children={"Short Term Corrective Action:"}
                           />
                        }
                     />
                     <Row className="newCorrectiveAction">
                        <Col xs={{ size: 6, offset: 3 }} className="text-white">
                           <Input
                              type="textarea"
                              className="serviceThreadTextArea"
                              value={supplierActionDto.shortTerm}
                              maxLength={255}
                              style={{ height: "150px", marginTop: "4px" }}
                              onChange={(e) => onChange("shortTerm", e.target.value)}
                              placeholder={"Enter Description..."}
                           />
                        </Col>
                     </Row>
                     <Row
                        children={
                           <Col
                              xs={{ size: 6, offset: 3 }}
                              className="text-white"
                              children={"Long Term Corrective Action:"}
                           />
                        }
                     />
                     <Row className="newCorrectiveAction">
                        <Col xs={{ size: 6, offset: 3 }} className="text-white">
                           <Input
                              type="textarea"
                              className="serviceThreadTextArea"
                              value={supplierActionDto.longTerm}
                              maxLength={255}
                              style={{ height: "150px", marginTop: "4px" }}
                              onChange={(e) => onChange("longTerm", e.target.value)}
                              placeholder={"Enter Description..."}
                           />
                        </Col>
                     </Row>
                     <Row className="newCorrectiveAction">
                        <ColPrompt title="Corrective Action By" />
                        <Col xs={6} className="text-white">
                           <Input
                              type="text"
                              value={supplierActionDto.actionBy}
                              onChange={(e) => onChange("actionBy", e.target.value)}
                           />
                        </Col>
                     </Row>
                     <Row className="newCorrectiveAction">
                        <ColPrompt title="Title" />
                        <Col xs={6} className="text-white">
                           <Input
                              type="text"
                              value={supplierActionDto.actionByTitle}
                              onChange={(e) => onChange("actionByTitle", e.target.value)}
                           />
                        </Col>
                     </Row>
                     <Row className="newCorrectiveAction">
                        <ColPrompt title="Corrective Action Date" />
                        <Col xs={6} className="text-white">
                           <DebounceInput
                              type="date"
                              onChange={(e) => onChange("actionDate", e.target.value)}
                              value={
                                 _.isNil(supplierActionDto.actionDate)
                                    ? ""
                                    : dateHelpers.formatDateForServer(supplierActionDto.actionDate)
                              }
                              debounceTimeout={500}
                           />
                        </Col>
                     </Row>
                     <hr />
                     <Row
                        children={
                           <Col
                              xs={{ size: 6, offset: 3 }}
                              className="text-white"
                              children={"Approval Comments:"}
                           />
                        }
                     />
                     <Row className="newCorrectiveAction">
                        <Col xs={{ size: 6, offset: 3 }} className="text-white">
                           <Input
                              type="textarea"
                              className="serviceThreadTextArea"
                              value={supplierActionDto.approvalComments}
                              maxLength={255}
                              style={{ height: "150px", marginTop: "4px" }}
                              onChange={(e) => onChange("approvalComments", e.target.value)}
                              placeholder={"Enter approval comment..."}
                           />
                        </Col>
                     </Row>
                     <Row className="newProductionItemLine">
                        <Col xs="3" />
                        <RadioOption
                           classType={status.Closed}
                           currentValue={supplierActionDto.status}
                           onChange={() => onChangeStatus("status", status.Closed?.value)}
                           fieldName="correctiveStatus"
                        />
                        <RadioOption
                           classType={status.Canceled}
                           currentValue={supplierActionDto.status}
                           onChange={() => onChangeStatus("status", status.Canceled?.value)}
                           fieldName="correctiveStatus"
                        />
                     </Row>
                     <Row className="newCorrectiveAction">
                        <ColPrompt title="Approved By" />
                        <Col xs={6} className="text-white">
                           <h5>{supplierActionDto.approvedBy}</h5>
                        </Col>
                     </Row>
                     <Row className="newCorrectiveAction">
                        <ColPrompt title="Approval Date" />
                        <Col xs={6} className="text-white">
                           <h5>
                              {supplierActionDto.approvalDate
                                 ? dateHelpers.toLongDateString(supplierActionDto.approvalDate)
                                 : null}
                           </h5>
                        </Col>
                     </Row>
                     <hr />
                     <Row>
                        <Col xxl={{ size: 8, offset: 2 }}>
                           <Card className="dashboard-card">
                              <CardBody>
                                 <AttachmentManager
                                    attachmentTypeId={constants.ATTACHMENT_TYPES.SupplierCorrectiveAction}
                                    contextName={supplierActionDto.displayId}
                                    attachmentKey={supplierActionDto.displayId}
                                 />
                              </CardBody>
                           </Card>
                        </Col>
                     </Row>
                     <Row>
                        <div className="inline d-flex justify-content-center">
                           <Button
                              className="shredButton"
                              children={"Save Changes"}
                              onClick={() => SaveCorrectiveAction()}
                           />
                           <Button
                              className="shredButton mx-5"
                              children={"Print Report"}
                              onClick={() => runReport()}
                           />
                        </div>
                     </Row>
                  </div>
               </fieldset>
            </form>
            <Row className="mt-3">
               <div className="inline d-flex justify-content-center">
                  <Button
                     className="shredButton"
                     children={"Cancel Return To Search"}
                     onClick={() => navigate(constants.ENDPOINTS.correctiveActionSearch)}
                  />
               </div>
            </Row>
         </ServiceThreadSpinner>
      </DesktopContainer>
   );
}
